import { createContext, ReactElement, useContext } from "react";
import ServicesInfoPg, { ServicesLideresProps } from "../services/getUsuariosConexao";

export const ListaContext = createContext<ServicesLideresProps>(null);


export const ProviderListMembro = ({children}: { children: ReactElement }) => {

  const context = ServicesInfoPg()

  return (
    <>
      <ListaContext.Provider value={context}>
        {children}
      </ListaContext.Provider>
    </>
  )
}

export const UseListMembros = () => {
  const context = useContext(ListaContext);
  return context;
}
